(function () {
  'use strict';

  function initHeroSlideshow(root) {
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('.hero-slideshow__slide')
    );
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('.hero-slideshow__dot')
    );

    if (slides.length < 2) return;

    var intervalMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 6000;
    var reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    var current = 0;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function next() {
      goTo(current + 1);
    }

    function start() {
      if (reduceMotion || timer) return;
      timer = window.setInterval(next, intervalMs);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stop();
        goTo(i);
        start();
      });
    });

    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    start();
  }

  function initAll() {
    document
      .querySelectorAll('[data-hero-slideshow]')
      .forEach(initHeroSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('[data-hero-slideshow]');
    if (el) initHeroSlideshow(el);
  });
})();